

























import Vue from 'vue'
import SingleMessage from './SingleMessage'
import helpers from '../../../helpers'
import { UserProfile } from '@/types/users'
import { sortBy } from 'lodash'
import './MessagePane.scss'
import { CastChatMessage } from '@/types/casts'

export default Vue.extend({
  name: 'MessagePane',
  props: {
    messages: {
      type: Array as () => CastChatMessage[],
      required: true
    },
    author: {
      type: String,
      required: true
    },
    authorColor: {
      type: String,
      required: false
    },
    authorTextColor: {
      type: String,
      required: true
    },
    defaultColor: {
      type: String,
      required: true
    },
    defaultTextColor: {
      type: String,
      required: true
    },
    currentUser: {
      type: String
    },
    users: {
      type: Array as () => UserProfile[],
      required: true
    },
    mini: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    messages () {
      setTimeout(() => { this.updateScroll() }, 200)
    }
  },
  computed: {
    sortedMessages (): CastChatMessage[] {
      // timestamp is set by firestore server (so might have latency before it's correct)
      return sortBy(this.messages, (m) => {
        const missingTimestamp = !m || !m.timestamp || !m.timestamp.toDate
        if (missingTimestamp) {
          // added to avoid "jumping" effect while timestamp is being updated
          return new Date().getTime()
        }

        return m.timestamp.toDate().getTime()
      })
    }
  },
  created () {
    this.ref = helpers.makeId()
  },
  mounted () {
    setTimeout(() => {
      this.updateScroll()
    }, 1000)
  },
  data: () => ({
    ref: ''
  }),
  methods: {
    isAuthor (paramAuthor): boolean {
      return this.currentUser === paramAuthor
    },
    findAuthorInTeam (paramAuthor): UserProfile {
      const author = this.users.find(u => u.user_id === paramAuthor)
      return author !== undefined ? author : {} as UserProfile
    },
    updateScroll () {
      const messageDisplay = this.$refs[this.ref] as HTMLElement
      if (messageDisplay) {
        messageDisplay.scrollTop = messageDisplay.scrollHeight + 70
      }
    },
    authorSelected (paramMessage) {
      this.$emit('userSelected', paramMessage)
    }
  },
  components: {
    SingleMessage
  }
})
